import { routeToProduct } from '@/helpers';

import ImageCard from '@/components/@general/ImageCard/index.vue';
import StarRating from 'vue-star-rating';
import IconVerify from '@/components/icons/IconVerify.vue';

export default {
  name: 'ReviewClientCard',
  components: {
    IconVerify,
    ImageCard,
    StarRating
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isCanVerify: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },

  created() {},
  mounted() {},
  computed: {},

  methods: {
    routeToProduct
  }
};
